module.exports = __webpack_public_path__ + "static/media/42x40-3.a3a96242.png";